"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Parser;

function Parser(parsingMethods) {
  var queue = parsingMethods.getMethods();
  return {
    finished: function finished() {
      return queue.length === 0;
    },
    next: function next() {
      if (this.finished()) {
        return false;
      }

      return queue.shift().apply(undefined, arguments);
    }
  };
}